var ProductAccessoriesCarousel = (function($) {
  var _public = {};
  var _private = {};

  _private.products_html = [];

  _private.carousel_selector = '';

  _public.init = function(product_handles, carousel_selector) {
    _private.products_html = [];// empty array upon initialization, as this module is reused in some cases
    _private.carousel_selector = carousel_selector;
    _public.getProductsViaAJAX(product_handles);
  }

  _public.getProductsViaAJAX = function(product_handles) {
    var product_handles = product_handles.split(',');

    for (var i = 0; i < product_handles.length; i++) {
      var product_handle = handleize(product_handles[i]);

      var params = {
        type: 'GET',
        url: '/products/' + product_handle + '?view=grid-item',
        dataType: 'HTML',
        success: function(product_html) {
          _private.products_html.push(product_html);
          // The following only executes once data for all products has been collected
          if (_private.products_html.length === product_handles.length) {
            _public.buildCarousel();
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          _private.products_html.push('');
          if (_private.products_html.length === product_handles.length) {
            _public.buildCarousel();
          }
        }
      };
      $.ajax(params);
    };
  };

  _public.buildCarousel = function() {
    var $carousel = $(_private.carousel_selector);
    var html = '';


    for (var i = 0; i < _private.products_html.length; i++) {
      html += _private.products_html[i];
    };
    $carousel.html(html);

    var screen_width = $(window).width();

    if (screen_width > 768) {
      $carousel.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        centerMode: false,
        variableWidth:false
      });
    }

  };

  return _public;

  function handleize(t) {
    return t=t.toLowerCase(),t=t.replace(/'|\"|\(|\)|\[|\]/g,""),t=t.replace(/\W+/g,"-"),"-"===t.slice(-1)&&(t=t.replace(/-+$/,"")),"-"===t.slice(0,1)&&(t=t.replace(/^-+/,"")),t
  }

}(jQuery));
